var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65625 8.00391C8.90234 8.27734 8.90234 8.6875 8.65625 8.93359C8.38281 9.20703 7.97266 9.20703 7.72656 8.93359L4.5 5.67969L1.24609 8.93359C0.972656 9.20703 0.5625 9.20703 0.316406 8.93359C0.0429688 8.6875 0.0429688 8.27734 0.316406 8.00391L3.57031 4.75L0.316406 1.49609C0.0429688 1.22266 0.0429688 0.8125 0.316406 0.566406C0.5625 0.292969 0.972656 0.292969 1.21875 0.566406L4.5 3.84766L7.75391 0.59375C8 0.320312 8.41016 0.320312 8.65625 0.59375C8.92969 0.839844 8.92969 1.25 8.65625 1.52344L5.40234 4.75L8.65625 8.00391Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1e19fda351b18e3a2b380bd4bfe3927d.svg";
export { ForwardRef as ReactComponent };